import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/plant-3/(processes-screens)/processes-management/"
)({
  beforeLoad: () => {
    throw redirect({
      to: "/plant-3/processes-management/processes",
    });
  },
});
